module.exports = __webpack_public_path__ + "img/icon-3.80bd59a1.svg";